export default __webpack_public_path__ + "static/media/Agilent.89640f87.png";